import { registerComponent } from '@gig/magic-common';
import VerifyEmailComponent from './verify-email.vue.js';

var VerifyEmail = registerComponent(VerifyEmailComponent);

export { VerifyEmail };
